module.exports = __webpack_public_path__ + "img/Abdullah.e313aec1.jpg";